import { useState, useEffect, useContext } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { CarritoContext } from '../context/carritoContext'
import { LoginContext } from '../context/loginContext'
import CalificacionProducto from '../publicaciones/calificacionProducto/CalificacionProducto'
import Descripcion from '../publicaciones/Descripcion'
import DetalleCabecera from '../publicaciones/DetalleCabecera'
import InformacionVendedor from '../publicaciones/InformacionVendedor'
import Metadatos from '../publicaciones/Metadatos'
import { MensajeriaNew } from '../reutilizables/mensajeria/MensajeriaNew'
import * as calificacionService from '../servicios/calificacionService'
import * as datosFiscalesService from '../servicios/datosFiscalesService'
import * as provinciasService from '../servicios/fetchProvinciasAPI'
import * as mensajesService from '../servicios/mensajesService'
import * as publicacionesService from '../servicios/publicacionesService'
import * as reputacionService from '../servicios/reputacionService'
import BordeDetalle from '../ui/BordeDetalle'
import styles from './PublicacionDetalle.module.css'

const ID_PUB_ESTADO_PUBLICADA = 2

const PublicacionDetalle = () => {
  const usuario = parseInt(localStorage.getItem('idUsuario'))
  const { loginDataContext } = useContext(LoginContext)
  const tipoUsuario = loginDataContext.tipoUsuario
  const { id } = useParams()
  const navigate = useNavigate()
  const [publicacion, setPublicacion] = useState([])
  const [reputacion, setReputacion] = useState(0)
  const [calificacion, setCalificacion] = useState(0)
  const [mensajes, setMensajes] = useState([])
  const [datosFiscales, setDatosFiscales] = useState([])
  const [provincias, setProvincias] = useState([])
  const { setCantidadCompra } = useContext(CarritoContext)

  const buscarMensajes = async () => {
    const { data } = await mensajesService.buscarPorPublicacion(id)
    const mapa = {}
    data.forEach((msj) => {
      if (!msj.idMensajePadre) mapa[msj.idMensaje] = { ...msj }
    })
    data.forEach((msj) => {
      if (msj.idMensajePadre && mapa[msj.idMensajePadre] && !mapa[msj.idMensajePadre].textoRta) {
        mapa[msj.idMensajePadre].textoRta = msj.texto
        mapa[msj.idMensajePadre].fechaEscritoRta = msj.fechaEscrito
      }
    })
    const raices = Object.values(mapa).sort(
      (a, b) => new Date(b.fechaEscrito) - new Date(a.fechaEscrito)
    )
    setMensajes(raices)
  }

  const obtenerPublicacion = async () => {
    const publicacionRes = await publicacionesService.buscarDetalle(id)
    const publicacionData = publicacionRes.data
    setPublicacion(publicacionData)

    const reputacionRes = await reputacionService.buscarReputacion(publicacionData.idVendedor)
    setReputacion(reputacionRes.data)

    const calificacionRes = await calificacionService.buscarCalificacion(id)
    setCalificacion(calificacionRes.data)

    const datosFiscalesRes = await datosFiscalesService.buscarTodos(publicacionRes.data.idVendedor)
    setDatosFiscales(datosFiscalesRes.data)

    const provinciasRes = await provinciasService.buscarProvinciasEnEBM()
    setProvincias(provinciasRes.data)

    await buscarMensajes()
  }

  const mostrarMensajeImpuestos = () => {
    if (!datosFiscales || datosFiscales.length === 0) {
      return false
    }
    return datosFiscales.some((df) => df.esAgentePercepcion === true)
  }

  const obtenerProvinciasPercepcion = () => {
    if (!datosFiscales || datosFiscales.length === 0 || !provincias || provincias.length === 0) {
      return []
    }

    const idsProvincias = datosFiscales
      .filter((df) => df.esAgentePercepcion === true)
      .map((df) => Number(df.idProvincia))

    const nombresProvincias = provincias
      .filter((p) => idsProvincias.includes(Number(p.idProvincia)))
      .map((p) => p.nombre)

    return nombresProvincias
  }

  useEffect(() => {
    obtenerPublicacion()
    setCantidadCompra(1)
  }, [id])

  const onCerrarClick = () => {
    navigate(-1)
    setCantidadCompra(1)
  }
  return (
    <BordeDetalle titulo={'Detalle Publicación'} onCerrarClick={() => onCerrarClick()}>
      <DetalleCabecera
        detalle={publicacion}
        permiteComprar={
          publicacion?.idVendedor !== usuario &&
          publicacion.idPublicacionEstado === ID_PUB_ESTADO_PUBLICADA
        }
      />
      <Descripcion descripcion={publicacion?.descripcion} />
      <div className={styles.metaRow}>
        <div className={styles.metaLeft}>
          <Metadatos idPublicacion={publicacion?.idPublicacion} />
        </div>
        {tipoUsuario !== 'R' && mostrarMensajeImpuestos() && (
          <div className={styles.metaRight}>
            <div className={styles.noticeBox}>
              <strong>Importante:</strong> Este vendedor es agente de percepción en
              {obtenerProvinciasPercepcion().length > 0 && (
                <> {obtenerProvinciasPercepcion().join(', ')}</>
              )}
              . Al confirmar la compra vas a visualizar el cálculo correspondiente de impuestos.
            </div>
          </div>
        )}
      </div>
      <div className={styles.flexContainer}>
        <MensajeriaNew
          titulo={'Preguntas'}
          id={id}
          tipoDoc={'publicacion'}
          idVendedor={publicacion?.idVendedor}
          mensajes={mensajes}
          tipoMensajes={'preguntas'}
          usuario={usuario}
          idComprador={usuario}
          actualizarMensajes={buscarMensajes}
          idPublicacionEstado={publicacion?.idPublicacionEstado}
        />
        <InformacionVendedor
          reputacion={reputacion.length > 0 ? reputacion : 0}
          publicacion={publicacion}
        />
      </div>

      {calificacion.length > 0 && <CalificacionProducto calificacion={calificacion} />}
    </BordeDetalle>
  )
}

export default PublicacionDetalle
